<p-toast [breakpoints]="{ '420px': { width: '100%', right: '0', left: '0' } }"></p-toast>
        <div class="back-outer mobile-back" routerLink="/">
  <p>Back to home</p>
</div>
<section class="onboarding-outer">
    <div class="landing-container">
        <div class="onboarding-banner">
            <h3>Greetings from a world where every mile counts!</h3>
            <p>Thank you for your interest in Trucklots </p>
        </div>
    </div>
</section>
<section class="navigate-outer">
    <div class="landing-container">
        <div class="sign-outer">
            <h5 *ngIf="headerText">Sign Up</h5>
        </div>

        <form [formGroup]="signupform" class="form custom-signup1" *ngIf="isSignUp">
            <div class="driver-grid">
                <div class="grid">
                    <div class="col-12 lg:col-3 md:col-6">
                        <div class="gen-email">
                            <label for="firstname">First Name<span class="custom-star">*</span></label>
                            <input pInputText id="firstname" NoLeadingSpaceDirective placeholder="Enter First Name" aria-describedby="username-help"
                                formControlName="name" maxlength="50" (keydown)="dialogControlService.noNumbersValidator($event)" />

                            <div *ngIf="signupform.get('name')?.touched || signupform.get('name')?.dirty" class="validation-error">

<div *ngIf="signupform.get('name')?.hasError('required')">
                                    This field is required*
                                </div>

<div *ngIf="!signupform.get('name')?.hasError('required') &&
                                          signupform.get('name')?.hasError('leadingSpace')">
                                    First Name cannot start with a space.*
                                </div>

<div *ngIf="!signupform.get('name')?.hasError('required') &&
                                          !signupform.get('name')?.hasError('leadingSpace') &&
                                          signupform.get('name')?.hasError('pattern')">
                                    Please enter only characters*
                                </div>

<div *ngIf="!signupform.get('name')?.hasError('required') &&
                                          !signupform.get('name')?.hasError('leadingSpace') &&
                                          !signupform.get('name')?.hasError('pattern') &&
                                          signupform.get('name')?.hasError('minlength')">
                                    Minimum 3 characters are required*
                                </div>

<div *ngIf="!signupform.get('name')?.hasError('required') &&
                                          !signupform.get('name')?.hasError('leadingSpace') &&
                                          !signupform.get('name')?.hasError('pattern') &&
                                          !signupform.get('name')?.hasError('minlength') &&
                                          signupform.get('name')?.hasError('maxlength')">
                                    Maximum 50 characters are required*
                                </div>

                            </div>

                        </div>

                    </div>
                    <div class="col-12 lg:col-3 md:col-6">
                        <div class="gen-email">
                            <label for="lastname">Last Name <span *ngIf="requiredLastNameAsterisk" class="custom-star">*</span> </label>
                            <input pInputText  NoLeadingSpaceDirective id="lastname" placeholder="Enter Last Name"
                                aria-describedby="username-help" formControlName="lastName" maxlength="50"
                                (keydown)="dialogControlService.noNumbersValidator($event)" />
                            <div *ngIf="signupform.get('lastName')?.touched || signupform.get('lastName')?.dirty" class="validation-error">

<div *ngIf="signupform.get('lastName')?.hasError('required')">
                                    This field is required*
                                </div>

<div *ngIf="!signupform.get('lastName')?.hasError('required') &&
                                          signupform.get('lastName')?.hasError('leadingSpace')">
                                    First Name cannot start with a space.*
                                </div>

<div *ngIf="!signupform.get('lastName')?.hasError('required') &&
                                          !signupform.get('lastName')?.hasError('leadingSpace') &&
                                          signupform.get('lastName')?.hasError('pattern')">
                                    Please enter only characters*
                                </div>

<div *ngIf="!signupform.get('lastName')?.hasError('required') &&
                                          !signupform.get('lastName')?.hasError('leadingSpace') &&
                                          !signupform.get('lastName')?.hasError('pattern') &&
                                          signupform.get('lastName')?.hasError('minlength')">
                                    Minimum 3 characters are required*
                                </div>

<div *ngIf="!signupform.get('lastName')?.hasError('required') &&
                                          !signupform.get('lastName')?.hasError('leadingSpace') &&
                                          !signupform.get('lastName')?.hasError('pattern') &&
                                          !signupform.get('lastName')?.hasError('minlength') &&
                                          signupform.get('lastName')?.hasError('maxlength')">
                                    Maximum 50 characters are required*
                                </div>
                            </div>
                            </div>
                            </div>
                    <div class="col-12 lg:col-3 md:col-6">
                        <div class="country-code">
                            <label for="phone">Mobile Number <span *ngIf="requiredLastNameAsterisk" class="custom-star">*</span></label>
                            <ngx-intl-tel-input [cssClass]="'custom'" [preferredCountries]="preferredCountries" [enableAutoCountrySelect]="true" id="phone"
                                [enablePlaceholder]="true" [searchCountryFlag]="true"
                                [searchCountryField]="[SearchCountryField.Iso2,SearchCountryField.Name]" [selectFirstCountry]="false"
                                [selectedCountryISO]="countryISO.UnitedStates" [maxLength]="10" [phoneValidation]="true"
                                [separateDialCode]="separateDialCode" [numberFormat]="PhoneNumberFormat.National"
                                customPlaceholder="Enter Mobile Number" name="phone" formControlName="phone">
                            </ngx-intl-tel-input>
                            <div class="error-outer">
                                <div
                                    *ngIf="signupform.get('phone').hasError('required') && signupform.get('phone').dirty && signupform.get('phone').touched">
                                    <small class="validation-error">This field is required*</small>
                                </div>
                                <div
                                    *ngIf="!signupform.get('phone').hasError('required') && signupform.get('phone').touched && signupform.get('phone').invalid">
                                    <small class="validation-error">Mobile number is not valid*</small>
                                </div>
                            </div>
                            </div>
                            </div>

                    <div class="col-12 lg:col-3 md:col-6">
                        <div class="gen-email">
                            <label for="email">Email <span *ngIf="requiredLastNameAsterisk" class="custom-star">*</span></label>
                            <input pInputText id="email" placeholder="Enter Email" aria-describedby="email-help"
                                formControlName="email" />
                            <div *ngIf="signupform.get('email').hasError('required') &&( signupform.get('email').touched || signupform.get('email').dirty)"
                                class="validation-error">This field is required*</div>
                            <div *ngIf="signupform.get('email').hasError('pattern') && (signupform.get('email').touched || signupform.get('email').dirty)"
                                class="validation-error">Please enter a valid email*</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="grid">
                <div class="col-12 lg:col-3 md:col-6">
                    <div class="gen-email">
                        <label for="password">Password<span class="custom-star">*</span></label>
                        <p-password class="small-placeholder" indicator="false" [toggleMask]="true" [feedback]=false
                            id="password" placeholder="Enter Password" maxlength="15"
                            (keydown)="onPasswordKeyDown($event, 'Password')" formControlName="Password"></p-password>
                        <div class="error-outer"
                            *ngIf="signupform.get('Password').invalid && (signupform.get('Password').dirty || signupform.get('Password').touched)">
                            <div *ngIf="signupform.get('Password').hasError('required')" class="validation-error">
                                Password is required.</div>
                            <div *ngIf="signupform.get('Password').hasError('invalidPassword')"
                                class="validation-error">
                                Length must be 8-15 with uppercase, lowercase, number & special characters.
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-12 lg:col-3 md:col-6">
                    <div class="gen-email">
                        <label for="confirmpassword">Confirm Password<span class="custom-star">*</span></label>
                        <p-password class="small-placeholder" indicator="false" [toggleMask]="true" [feedback]=false
                            id="confirmpassword" placeholder="Enter Confirm Password" maxlength="15"
                            (keydown)="onPasswordKeyDown($event, 'ConfirmPassword')"
                            formControlName="ConfirmPassword"></p-password>
                        <div class="error-outer"
                            *ngIf="signupform.get('ConfirmPassword').invalid && (signupform.get('ConfirmPassword').dirty || signupform.get('ConfirmPassword').touched)">
                            <div *ngIf="signupform.get('ConfirmPassword').hasError('required')"
                                class="validation-error">Confirm Password is required.</div>
                            <div *ngIf="signupform.get('ConfirmPassword').hasError('invalidPassword')"
                                class="validation-error">
                                Length must be 8-15 with uppercase, lowercase, number & special characters.
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-12 lg:col-3 md:col-6">
                    <div class="submit-outer custom-promo-code">
                        <div class="promo-code country-code">
                            <label> &nbsp;</label>
                            <h5 *ngIf="couponValidityData?.offerStatus != 'Active'" (click)="openPromoCodeModal()">Have
                                a promo
                                code?</h5>
                            <div class="promo-code">
                            </div>
                            <h4 *ngIf="couponValidityData?.offerStatus === 'Active'">Promo applied <svg width="16"
                                    height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <g clip-path="url(#clip0_6747_136912)">
                                        <path
                                            d="M8 0C3.58867 0 0 3.58867 0 8C0 12.4113 3.58867 16 8 16C12.4113 16 16 12.4113 16 8C16 3.58867 12.4113 0 8 0ZM7.93933 10.2793C7.68891 10.5277 7.35033 10.6667 6.99765 10.6661C6.64496 10.6655 6.30688 10.5252 6.05733 10.276L4.20267 8.47867L5.13133 7.52067L6.99333 9.32533L10.866 5.52467L11.802 6.47467L7.93933 10.2793Z"
                                            fill="#03C539" />
                                    </g>
                                    <defs>
                                        <clipPath id="clip0_6747_136912">
                                            <rect width="16" height="16" fill="white" />
                                        </clipPath>
                                    </defs>
                                </svg>
                            </h4>
                        </div>
                    </div>
                </div>
            </div>
            <div class="checkbox-outer">
                <div class="flex align-items-center gap-1">
                    <p-checkbox formControlName="termsCondition" [binary]="true" inputId="termsCondition"
                        (onChange)="onCheckboxSelect()"></p-checkbox>
                    <label for="termsCondition">I agree to the <a id="termsAndConditions" href="terms-and-conditions" class="cursor-pointer" target="_blank"
                            rel="noopener noreferrer">Terms & Conditions</a></label>
                </div>
            </div>
            <div class="submit-outer">
                <p-button type="submit" label="Create Account" (onClick)="submit()"></p-button>
                <p class="error-outer"></p>
            </div>
        </form>
        <div class="content custom-otp custom-height" *ngIf="showOtpComponent">
            <div class="o-c">
                <div class="card">
                    <p class="a-o-i">Enter verification Passcode</p>
                    <ng-otp-input #ngOtpInput (onInputChange)="onOtpChange($event)" [config]="config"></ng-otp-input>
                </div>
                <div class="otp-btn">
                    <div class="submit-outer">
                        <p-button type="submit" label="Verify" (onClick)="verifyEmailByOTP()"></p-button>
                    </div>
                    <div class="count12" *ngIf="!showButton">
                        <p class="resend">Resend passcode in {{ countDown }}</p>
                    </div>
                    <div class="resend-code" *ngIf="showButton">
                        <a href="#" (click)="onClickSendOtp($event)">Resend Passcode</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
<section class="copy-right1">
    <div class="abc">
        <div class="landing-container">
            <div class="grid">
                <div class="col-12 lg:col-6 md:col-6">
                    <div class="copy-email">
                        <p>support&#64;trucklots.com</p>
                    </div>
                </div>
                <div class="col-12 lg:col-6 md:col-6">
                    <div class="copyright-outer">
                        <p>Copyright © 2024. All rights reserved by Trucklots.</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
